import { isValue } from './is-defined'
import { sortLocale } from './sort-locale'
import store from '../store'

function sortByKey (arr, key, reverse) {
  arr.sort((a, b) => {
    if (a[key] > b[key]) {
      return reverse ? -1 : 1
    }
    if (a[key] < b[key]) {
      return reverse ? 1 : -1
    }
    return 0
  })
  return arr
}

function sortTable (dataset, sort, format) {
  if (!sort || !sort.field) return dataset
  return [...dataset].sort((ee1, ee2) => {
    const v1 = format(ee1, sort.field)
    const v2 = format(ee2, sort.field)
    if (sort.direction === 'asc') {
      return v1 >= v2 ? 1 : -1
    }
    if (sort.direction === 'desc') {
      return v1 >= v2 ? -1 : 1
    }
    return 0
  })
}

// return sorted array of employees, based on:
//   1) 'external' (internal are before external)
//   2) 'lastName' and then 'firstName' (if 'lastName' exists)
//   3) 'name' (if 'lastName' didn't exist)
function sortEmployees (empsPar) {
  const emps = Array.isArray(empsPar) ? empsPar : Object.values(empsPar)
  const locale = store.getState().locale

  emps.sort((a, b) => {
    // Check 'external' property
    const aExternal = a.external === true
    const bExternal = b.external === true
    if (!aExternal && bExternal) return -1
    if (aExternal && !bExternal) return 1

    const aName = `${a.lastName ?? ''} ${a.firstName ?? ''}`
    const bName = `${b.lastName ?? ''} ${b.firstName ?? ''}`

    if (isValue(a.lastName) && isValue(b.lastName)) {
      return sortLocale(aName, bName, locale)
    }

    if (isValue(a.lastName) && !isValue(b.lastName)) {
      return -1
    }

    if (!isValue(a.lastName) && isValue(b.lastName)) {
      return 1
    }

    return sortLocale(a.firstName ?? '', b.firstName ?? '', locale)

    // // Check 'lastName' or 'name' property
    // const aLastName = (a.lastName || a.name)?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    // const bLastName = (b.lastName || b.name)?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    // // if (aLastName < bLastName) return -1
    // // if (aLastName > bLastName) return 1
    // if(isDefined(aLastName) && isDefined(aFirstName)){
    //   return sortLocale(aLastName, bLastName, store.getState().locale)
    // }

    // // Check 'firstName' property, if 'lastName'/'name' are the same or nonexistent
    // const aFirstName = (a.firstName?.normalize('NFD').replace(/[\u0300-\u036f]/g, '') || '').toLowerCase()
    // const bFirstName = (b.firstName?.normalize('NFD').replace(/[\u0300-\u036f]/g, '') || '').toLowerCase()
    // // if (aFirstName < bFirstName) return -1
    // // if (aFirstName > bFirstName) return 1

    // if(isDefined(aFirstName) && isDefined(bFirstName)) {
    //   return sortLocale(aFirstName, aLastName, store.getState().locale)
    // }
  })

  return emps
}

export const compare = (a, b) => a > b ? 1 : a < b ? -1 : 0

export default {
  sortTable,
  sortByKey,
  sortEmployees
}
